import { IconCloseSmall } from '@pijma/icon-gallery/crypto'

import styled from 'styled-components'

import { H4 } from '../../header/Headings'
import { InfoSearchData } from './InfoSearchData'
import InputSearch from './InputSearch'

const ModalWrapper = styled.div<ModalWrapperProps>`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #fafafa;
  z-index: 1;
  display: ${(props) => (props.show ? 'block' : 'none')};
  overflow-y: auto;
`

const CloseButton = styled.div`
  display: flex;
  justify-content: center; /* по горизонтали */
  align-items: center; /* по вертикали */
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 16px;
  width: 32px;
  height: 32px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  cursor: pointer;
`

const ModalContent = styled.div`
  padding: 20px;
`

const ModalTitle = styled.span`
  margin-left: 4px;
  line-height: 28px;
  display: inline-block;
`

interface ModalWrapperProps {
  show: boolean
}

interface ModalProps {
  isOpen: boolean
  closeModal: () => void
  data: InfoSearchData[]
  searchTitle: string
  searchPlaceholder: string | undefined
  isSearchInputEnabled: boolean
  onSearchElementSelect: (selected: InfoSearchData) => void
}

const Modal = ({
  isOpen,
  closeModal,
  searchTitle,
  searchPlaceholder,
  isSearchInputEnabled,
  onSearchElementSelect,
  data,
}: ModalProps) => {
  return (
    <ModalWrapper show={isOpen}>
      <CloseButton>
        <IconCloseSmall width={24} height={24} onClick={closeModal} />
      </CloseButton>
      <ModalContent>
        <ModalTitle>
          <H4>{searchTitle}</H4>
        </ModalTitle>
        <InputSearch
          placeholder={searchPlaceholder}
          width={'100%'}
          onElementSelect={onSearchElementSelect}
          data={data}
          isInputEnabled={isSearchInputEnabled}
        />
      </ModalContent>
    </ModalWrapper>
  )
}

export default Modal
